<template>
    <div class="creat-order">
        <div class="order-info">
            <div class="info-address">
                <div class="list-left" v-if="user_take_goods_address.Phone">
                    <div class="left-t">
                        <span>{{user_take_goods_address.Name}}</span>
                        <span>{{user_take_goods_address.Phone}}</span>
                    </div>
                    <div class="left-b">
                        <span class="isnormal" v-if="user_take_goods_address.IsNormal">默认</span><span>{{user_take_goods_address.Address}}</span>
                    </div>
                </div>
                <div class="list-left" style="color: #999" v-if="!user_take_goods_address.Phone">
                    <h5>暂无地址，点击右侧图标前去选择</h5>
                </div>
                <div class="list-right" @click="chooseAddressClick"><i class="fa fa-chevron-right"></i></div>
            </div>
            <div class="info-detail">
                <div class="detail1"></div>
                <div class="detail2">
                    <div style="width: 70px;height: 70px"><img style="width: 70px;height: 70px" src="../../assets/img/mouse1.jpg" alt=""/></div>
                    <div style="flex: 1;padding: 0 5px">
                        <div style="height: 35px;overflow: hidden;font-size: 14px;margin-bottom: 15px;">备课小助手是一款将扫描功能置于鼠标内的智能设备，具备三维拼接图技术、OCR识别、AI人工智能识别，快速组卷功能及千万级题库备课资源、</div>
                        <div style="display: flex">
                            <div style="flex: 1">
                                <span>单价：</span>
                                <span style="color: #ff4f04;">{{mouse_price}}</span>
                            </div>
                            <div style="flex: 1;text-align: right">
                                <span @click="mouseMinus"><i class="fa fa-minus"></i></span>
                                <input @change="mouseNumChange" type="text" v-model="mouse_num" pattern="\d*"/>
                                <span @click="mouseAdd"><i class="fa fa-plus"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="detail3" @click="select">
                    <div class="view-left">
                        <span style="color: red">* </span>
                        <span>销售区域</span>
                    </div>
                    <div class="view-right" v-text="address?address:'点击选择省市区'"></div>
                    <!-- <mt-field :disabled="true" label="* 销售区域" @click.native.capture="select" placeholder="点击选择省市区1" type="text" v-model="address"></mt-field> -->
                </div>
                <div class="detail3" @click="selectSch">
                    <div class="view-left">
                        <span style="color: #fff">* </span>
                        <span>销售学校</span>
                    </div>
                    <div class="view-right" v-text="selschoolName?selschoolName:'选择区域后再选择学校（非必填）'"></div>
                    <!-- <mt-field :disabled="true" label="销售学校" @click.native.capture="selectSch()" placeholder="选择区域后再选择学校（非必填）" type="text" v-model="selschoolName"></mt-field> -->
                </div>
            </div>
            <div class="info-guize2">
                <div>风险提示：</div>
                <div>当您点击下面的"提交订单"按钮时：我们便确认您已阅读<a href="javascript:void(0);" @click="goGuize">销售规则</a>对于由此产生的争议风险损失，我们不承担任何连带责任。</div>
            </div>
        </div>
        <div class="order-bot">
            <div class="order-num">
                <span>合计:</span>
                <span>￥<span class="num">{{mouse_price*mouse_num}}</span></span>
            </div>
            <div class="submit-creat" @click="goCreatOrder">提交订单</div>
        </div>
        <yz-select v-if="show" :ref="show" @changeValue='isShow' :province='province' :city='city' :county='county'></yz-select>
        <yz-selectsch v-if="show_sch" :ref="show_sch" @changeValue='isShowSch' :areas='selAreaList'></yz-selectsch>
    </div>
</template>
<script>
import select from '@/components/select'
import selectSchool from '@/components/selectSchool'
export default {
    data() {
        return {
            codeValue: '获取验证码',
            validCode: true,
            show: false,
            show_sch: false,
            address: '',
            province: '',
            city: '',
            county: '',
            countyCodeID: {},
            mouse_num: 1,
            mouse_price: 799,
            summary: '123',
            user_take_goods_address: {},
            selAreaList: [],
            selSchoolList: [],
            selschoolName: ''
        }
    },
    components:{
        'yz-select': select,
        'yz-selectsch': selectSchool
    },
    methods: {
        goGuize() {
            let _this = this;
            let a = {
                AreaID: _this.countyCodeID.id,
                AreaName: _this.address,
                Summary: _this.summary,
                selschoolName: _this.selschoolName,
                selSchoolList: _this.selSchoolList,
                selAreaList: _this.selAreaList
            }
            window.localStorage.setItem('orderAuxiliaryInfo', JSON.stringify(a));
            this.$router.push({
                path: '/userinfo/guize'
            })
        },
        select(){
            this.show = true;
        },
        // 选择学校
        selectSch() {
            if(this.selAreaList.length>0) {
                this.show_sch = true;
            }else{
                this.abp.api.reqSuccess(this,'请先选择代理区域');
            }
        },
        isShow(msg){
            let selareanames = '';
            this.selAreaList.forEach(item=> {
                selareanames += item.AreaName;
            })
            let _this = this;
            this.show = msg.show;
            this.address = msg.result?msg.result:selareanames;
            this.province = msg.province;
            this.city = msg.city;
            this.county = msg.county;
            this.countyCodeID = msg.lastcityobj;
            if(msg.lastcityobj) {
                let arr = _this.selAreaList;
                for (let index = 0; index < arr.length; index++) {
                    if(arr[index].AreaID == msg.lastcityobj.id){
                        return;
                    }
                }
                _this.selAreaList = [];
                _this.selSchoolList = [];
                _this.selschoolName = '';
                _this.selAreaList.push({
                    AreaID: msg.lastcityobj.id,
                    AreaName: _this.address,
                    value: msg.lastcityobj.value
                })
            }
        },
        isShowSch(backdata) {
            let _this = this;
            _this.show_sch = backdata.show;
            if(backdata.school) {
                _this.selschoolName = backdata.school.FullName;
                let arr = _this.selSchoolList;
                for (let index = 0; index < arr.length; index++) {
                    if(arr[index].ID == backdata.school.ID){
                        return;
                    }
                }
                _this.selSchoolList = [];
                _this.selSchoolList.push({
                    ID: backdata.school.ID,
                    Name: backdata.school.FullName,
                    value: backdata.school.FullName
                })
            }
        },
        getCode(){
            var time=60;
            var that = this;
            if(this.validCode){
                this.validCode = false;
                this.codeValue =  time + '秒';
                var t = setInterval(getTime,1000)
            }
            function getTime(){
                time--;
                that.codeValue =  time + '秒';
                if (time == 0) {
                    clearInterval(t);
                    that.codeValue = '重新获取';
                    that.validCode=true;
                }
            }
        },
        mouseNumChange () {
            let mouse2 = Number(this.mouse_num);
            if(isNaN(mouse2)){
                this.mouse_num=1
            }else{
                this.mouse_num = parseInt(mouse2)
            }
        },
        mouseAdd() {
            let mouse2 = Number(this.mouse_num);
            if(isNaN(mouse2)){
                this.mouse_num=1
            }else{
                this.mouse_num = parseInt(++mouse2)
            }
        },
        mouseMinus() {
            let mouse2 = Number(this.mouse_num);
            if(isNaN(mouse2)||mouse2<2){
                this.mouse_num=1
            }else{
                this.mouse_num = parseInt(--mouse2)
            }
        },
        // 区更换地址
        chooseAddressClick() {
            let _this = this;
            let a = {
                AreaID: _this.countyCodeID.id,
                AreaName: _this.address,
                Summary: _this.summary,
                selschoolName: _this.selschoolName,
                selSchoolList: _this.selSchoolList,
                selAreaList: _this.selAreaList
            }
            window.localStorage.setItem('orderAuxiliaryInfo', JSON.stringify(a));
            window.sessionStorage.setItem('mouseNum', _this.mouse_num);
            window.sessionStorage.setItem('router_source', 'creatorder');
            this.$router.replace({
                path: '/userinfo/shipaddress'
            })
        },
        // 创建订单
        goCreatOrder() {
            let _this = this;
            if(!_this.user_take_goods_address.ID) {
                _this.abp.api.reqSuccess(_this,'收货地址不能为空');
                return;
            }
            if(!_this.countyCodeID.id) {
                _this.abp.api.reqSuccess(_this,'销售区域不能为空');
                return;
            }
            let aaaa = {
                AreaID: _this.countyCodeID.id,
                AreaName: _this.address,
                Summary: _this.summary,
                selschoolName: _this.selschoolName,
                selSchoolList: _this.selSchoolList,
                selAreaList: _this.selAreaList
            }
            window.localStorage.setItem('orderAuxiliaryInfo', JSON.stringify(aaaa));
            let reqData = {
                    AreaID: _this.countyCodeID.id,
                    AreaName: _this.address,
                    Summary: _this.summary,
                    MouseCount: _this.mouse_num,
                    AddressID: _this.user_take_goods_address.ID,
                    SchoolID: _this.selSchoolList.length>0?_this.selSchoolList[0].ID:'',
                    SchoolName: _this.selSchoolList.length>0?_this.selSchoolList[0].Name:''
                };
            _this.$indicator.open('加载中...');
            _this.abp.api.CreateOutBatch(reqData)
                .then((res) => {
                    if(res.status == 200) {
                        if(res.data.IsSuccess) {
                            _this.onBridgeReady(res.data.Data);
                        }else{
                            _this.$indicator.close();
                            _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                        }
                    }
                })
                .catch((error)=>{
                    _this.$indicator.close();
                    try {
                        switch(error.status) {
                            case 401:
                            _this.abp.api.reqSuccess(_this,'您没有权限！')
                        }
                    } catch (txt) {
                        console.log(txt);
                    }
                })
        },
        onBridgeReady(data) {
            let _this = this,
                paydata = data,
                appid = _this.abp.UserInfos.agentWxgzhConfig.AppID;
            // 现在暂时是老师支付
            if(data) {
                try{
                    if(paydata.nonceStr){
                        _this.$indicator.close();
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', {
                                "appId": appid,     //公众号名称，由商户传入     
                                "timeStamp": paydata.timeStamp.toString(),         //时间戳，自1970年以来的秒数     
                                "nonceStr": paydata.nonceStr, //随机串     
                                "package": paydata.package,     
                                "signType": "MD5",         //微信签名方式：     
                                "paySign": paydata.paySign //微信签名 
                            },
                            function(res){
                                console.log(res)
                                _this.$indicator.close();
                                if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                                    // 使用以上方式判断前端返回,微信团队郑重提示：
                                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                    _this.abp.api.reqSuccess(_this,'支付成功,已通知商家发货')
                                    setTimeout(() => {
                                        _this.$indicator.close();
                                        _this.$router.replace({
                                            path: '/order/myorder'
                                        })
                                    },2000)
                                }else if(res.err_msg == "get_brand_wcpay_request:cancel" ) {
                                    _this.abp.api.reqSuccess(_this,'您取消支付了,去我的订单查看')
                                    setTimeout(() => {
                                        _this.$indicator.close();
                                        _this.$router.replace({
                                            path: '/order/myorder'
                                        })
                                    },2000)
                                }else if(res.err_msg == "get_brand_wcpay_request:fail" ) {
                                    _this.abp.api.reqSuccess(_this,'订单支付失败了,到我的订单完成支付')
                                    setTimeout(() => {
                                        _this.$indicator.close();
                                        _this.$router.replace({
                                            path: '/order/myorder'
                                        })
                                    },2000)
                                }else{
                                    _this.abp.api.reqSuccess(_this,'支付缺少参数')
                                    setTimeout(() => {
                                        _this.$indicator.close();
                                        _this.$router.replace({
                                            path: '/order/myorder'
                                        })
                                    },2000)
                                }
                            }
                        );
                    }else{
                        _this.$indicator.close();
                        _this.abp.api.reqSuccess(_this,'订单创建有误')
                    }
                } catch (txt) {
                    _this.$indicator.close();
                }
            } else {
                _this.$indicator.close();
                _this.abp.api.reqSuccess(_this,'订单创建有误')
            }
        }
    },
    mounted() {
        let _this = this;
        _this.mouse_num = _this.$route.query.mouse_num;
        let changeAddress = sessionStorage.getItem('changeAddress');
        let orderAuxiliaryInfo = localStorage.getItem('orderAuxiliaryInfo');
        if(changeAddress) {
            _this.user_take_goods_address = JSON.parse(changeAddress);
        }
        if(orderAuxiliaryInfo) {
            try {
                let aa = JSON.parse(orderAuxiliaryInfo);
                _this.countyCodeID.id = aa.AreaID;
                _this.address = aa.AreaName;
                _this.summary = aa.Summary;
                _this.selschoolName = aa.selschoolName;
                _this.selSchoolList = aa.selSchoolList;
                _this.selAreaList = aa.selAreaList;
            } catch (error) {
                console.log(error)
            }
        }
        const getOrderPrice = new Promise((resolve, reject) => {
            _this.$indicator.open('加载中...');
            _this.abp.api.IsAreaAgent()
                .then((res)=> {
                    resolve();
                    if(res.status == 200) {
                        if(res.data.IsSuccess) {
                            _this.mouse_price = res.data.Data.ProductPrice;
                        }else{
                            _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                        }
                    }
                })
                .catch((error)=>{
                    resolve();
                    try {
                        switch(error.status) {
                            case 401:
                            _this.abp.api.reqSuccess(_this,'您没有权限！')
                        }
                    } catch (txt) {
                        console.log(txt);
                    }
                })
        })
        getOrderPrice
            .then(() => {
                if(changeAddress) {
                    _this.user_take_goods_address = JSON.parse(changeAddress);
                    _this.$indicator.close();
                } else {
                    try {
                        let user_info = window.sessionStorage.getItem('UserInfo');
                        if(user_info){
                            _this.userInfo = JSON.parse(_this.abp.f_Base64.decode(user_info));
                        }
                        _this.abp.api.GetAgentAddress(_this.userInfo.ID)
                            .then((res)=> {
                                _this.$indicator.close();
                                if(res.status == 200) {
                                    if(res.data.IsSuccess) {
                                        let addressArray = res.data.Data;
                                        if(addressArray.length == 0) {
                                            _this.user_take_goods_address = {};
                                        }else{
                                            for (let index = 0; index < addressArray.length; index++) {
                                                if(addressArray[index].IsNormal) {
                                                    _this.user_take_goods_address = addressArray[index];
                                                }
                                            }
                                            if(!_this.user_take_goods_address.ID) {
                                                _this.user_take_goods_address = addressArray[0];
                                            }
                                        }
                                    }else{
                                        _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                    }
                                }
                            })
                            .catch((error)=>{
                                _this.$indicator.close();
                                try {
                                    switch(error.status) {
                                        case 401:
                                        _this.abp.api.reqSuccess(_this,'您没有权限！')
                                    }
                                } catch (txt) {
                                    console.log(txt);
                                }
                            })
                    }catch(txt) {
                        _this.$indicator.close();
                        console.log('系统出错了')
                    }
                }
            })
    }
}
</script>
<style scoped>
    .creat-order .order-info {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 45px;
        overflow: auto;
        background-color: #f2f2f2;
    }
    .creat-order .order-info>.info-address {
        display: flex;
        height: 80px;
        border-radius: 10px;
        margin-top: 10px;
        background-color: #fff;
        margin-bottom: 10px;
        padding: 10px;
        padding-left: 30px;
        align-items: center;
    }
    .creat-order .order-info>.info-address>.list-left {
        flex: 1;
        padding: 5px 0;
    }
    .creat-order .order-info>.info-address>.list-left>.left-t {
        font-size: 16px;
    }
    .creat-order .order-info>.info-address>.list-left>.left-t>span:last-child {
        font-size: 12px;
        color: #ccc;
        padding-left: 20px;
    }
    .creat-order .order-info>.info-address>.list-left>.left-b {
        font-size: 14px;
        margin-top: 10px;
    }
    
    .creat-order .order-info>.info-address>.list-left .isnormal{
        padding: 2px 5px;
        margin-right: 5px;
        color: rgb(235, 114, 120);
        background-color: rgb(243, 187, 187);
    }
    .creat-order .order-info>.info-address>.list-right {
        width: 50px;
        font-size: 14px;
        color: #ccc;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-left: 1px solid #ccc;
        cursor: pointer;
    }
    .creat-order .order-info>.info-detail {
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
    }
    .creat-order .order-info>.info-detail>div {
        margin: 10px 0px;
    }
    .creat-order .order-info>.info-detail>.detail2 {
        align-items: center;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        padding: 0 10px;
    }
    .creat-order .order-info>.info-detail>.detail3 {
        display: flex;
        padding: 0 10px;
        align-items: center;
    }
    .creat-order .order-info>.info-detail>.detail3>.view-left {
        width: 100px;
    }
    .creat-order .order-info>.info-detail>.detail3>.view-right {
        flex: 1;
        padding: 5px;
        font-size: 14px;
        border-radius: 4px;
        color: rgb(84, 84, 84);
        background-color: rgb(235, 235, 228);
    }
    .order-info>.info-detail>.detail2>span:first-child {
        display: inline-block;
        width: 105px;
        text-align: right;
        padding-right: 10px;
    }
    .order-info>.info-detail>.detail2 input {
        font-size: 14px;
        width: 30px;
        text-align: center;
        margin: 0 10px;
    }
    .order-info>.info-guize {
        background-color: #fff;
        margin-top: 10px;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        padding: 10px;
    }
    .order-info>.info-guize > div:first-child {
        padding-left: 20px;
    }
    .order-info>.info-guize > div:last-child {
        padding-left: 10px;
    }
    .order-info>.info-guize > div:last-child>a {
        color: rgb(253, 93, 93);
    }
    .order-info>.info-guize2 {
        background-color: #fff;
        margin-top: 10px;
        padding: 10px;
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 10px;
    }
    .order-info>.info-guize2>div:first-child {
        padding-left: 20px;
    }
    .order-info>.info-guize2>div:last-child {
        padding-left: 20px;
        font-size: 14px;
        text-indent: 28px;
        color: #ccc
    }
    .creat-order>.order-bot {
        position: absolute;
        height: 45px;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 1px solid #eee;
        display: flex;
    }
    .creat-order>.order-bot .order-num {
        flex: 4;
        display: flex;
        justify-content: right;
        align-items: center;
        padding-right: 15px;
        padding-left: 10px;
    }
    .creat-order>.order-bot .order-num>span:last-child {
        color: #ff4f04;
    }
    .creat-order>.order-bot .order-num .num {
        font-size: 22px;
    }
    .creat-order>.order-bot .submit-creat {
        flex: 2;
        height: 45px;
        text-align: center;
        line-height: 45px;
        color: #fff;
        font-weight: 800;
        letter-spacing: 1px;
        font-size: 14px;
        background: -webkit-linear-gradient(left, #fb9100 , #ff4f04); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(right, #fb9100 , #ff4f04); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(right, #fb9100 , #ff4f04); /* Firefox 3.6 - 15 */
        background: linear-gradient(to right, #fb9100 , #ff4f04); /* 标准的语法 */
    }
    .creat-order .order-info .mint-field .mint-cell-title {
        width: 90px;
    }
    .creat-order .order-info .mint-field .mint-cell-value {
        border: 1px solid #ccc;
    }
    .mint-cell-wrapper {
        background-image: none;
    }
    .mint-cell:last-child {
        background-image: none;
    }
</style>

